import { Loader2 } from "lucide-react";
import { ORDER_STATUS } from "@/lib/format";

export const StatusBadge = ({ status, testId }) => {
  const meta = ORDER_STATUS[status] || ORDER_STATUS.menunggu;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-medium ${meta.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {meta.label}
    </span>
  );
};

export const PageLoader = ({ className = "min-h-[60vh]" }) => (
  <div className={`flex items-center justify-center ${className}`} data-testid="page-loader">
    <Loader2 className="h-6 w-6 animate-spin text-gold" />
  </div>
);

export const EmptyState = ({ icon: Icon, title, text, children, testId }) => (
  <div data-testid={testId} className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-white/10 px-6 py-16 text-center">
    {Icon && <Icon className="h-8 w-8 text-neutral-600" />}
    <p className="mt-4 font-display text-xl">{title}</p>
    {text && <p className="mt-2 max-w-sm text-sm text-neutral-500">{text}</p>}
    {children && <div className="mt-6">{children}</div>}
  </div>
);
